import * as sharedServices from "@emanprague/shared-services";
import { bound } from "@frui.ts/helpers";
import { BusyWatcher, Router, ScreenBase, watchBusy } from "@frui.ts/screens";
import { action, observable, runInAction } from "mobx";
import type { IAdminModule } from "viewModels/types";
import SimplePortalSettings from "entities/simplePortalSettings";
import { validate } from "@frui.ts/validation";
import PortalSettingsService from "services/portalSettingsService";

const navigationName = "notice-settings";

@Router.registerRoute({ name: Router.Self, route: `${navigationName}` })
export default class NoticeSettingsPageViewModel extends ScreenBase implements IAdminModule {
  navigationName = navigationName;
  orderIndex = 70;
  menuPart = "content";
  busyWatcher = new BusyWatcher();

  managedSettings = ["login_notice", "dashboard_notice"];
  @observable settings: SimplePortalSettings[];

  @observable errorMessage?: string;

  constructor(
    public localization: sharedServices.ILocalizationService,
    private portalSettingsService: PortalSettingsService
  ) {
    super();

    this.name = this.translate("title");

    runInAction(() => {
      this.settings = this.portalSettingsService
        .getValues("simple")
        .filter(setting => this.managedSettings.includes(setting.key))
        .sort((a, b) => this.managedSettings.indexOf(a.key) - this.managedSettings.indexOf(b.key));
    });
  }

  @action.bound
  @watchBusy
  async confirmRequest(setting: SimplePortalSettings) {
    validate(setting);

    if (setting) {
      await this.portalSettingsService.updatePortalSettings(setting);
    }
  }

  @bound translate(key: string) {
    return this.localization.translateGeneral(`admin.notice_settings.${key}`);
  }

  @bound translateGeneral(key: string) {
    return this.localization.translateGeneral(`general.${key}`);
  }
}
